import React, { Component, Fragment } from 'react'
import { Icon, message, Modal, Upload } from 'antd'
import { companies, files } from '@services/api'
import { inject, observer } from 'mobx-react'

function getBase64(file) {
    return new Promise((resolve, reject) => {
        const reader = new FileReader()
        reader.readAsDataURL(file)
        reader.onload = () => resolve(reader.result)
        reader.onerror = error => reject(error)
    })
}

function beforeUpload(file) {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png'
    if (!isJpgOrPng) {
        message.error('You can only upload JPG/PNG file!')
    }

    const isLt2M = file.size / 1024 / 1024 < 2
    if (!isLt2M) {
        message.error('IconUploader must smaller than 2MB!')
    }

    return isJpgOrPng && isLt2M
}

@inject((store: any) => {
    const { popupStore } = store
    return { popupStore }
})
@observer
class IconUploader extends Component<any, any> {
    state = {
        imageUrl: null,
        loading: false,
        previewVisible: false,
        previewImage: '',
        fileList: []
    }

    componentDidMount() {
        const { icon } = this.props.popupStore.info
        if (icon) {
            const fileList = [
                {
                    id: icon.id,
                    uid: '-1',
                    name: icon.file_name,
                    url: icon.url
                }
            ]
            this.setState({ fileList, loading: false })
        }
    }

    customRequest = async request => {
        const { bucket, related } = this.props
        this.setState({ loading: true })
        const newFile = await request.file
        const formData = new FormData()
        await formData.append('file', newFile)
        try {
            await files.upload(formData, { bucket, related, fileType: 'icon', uniq: true })
            await this.updateCompany()
            this.setState({ loading: false })
        } catch (e) {
            console.error('customRequest', e)
        }
    }

    handleCancel = () => this.setState({ previewVisible: false })

    handleRemove = async () => {
        this.setState({ loading: true })
        const { info } = this.props.popupStore
        try {
            const { id } = info.icon
            await files.delete({ id })
            await this.updateCompany()
            this.setState({ loading: false })
        } catch (e) {
            console.error('handleRemove')
        }
    }

    updateCompany = async () => {
        const { info, updateInfo } = this.props.popupStore
        const company = (await companies.getCompany({ id: info.id })).data
        await updateInfo(company)
    }

    render() {
        const { previewVisible, previewImage } = this.state
        const { icon } = this.props.popupStore.info

        let fileList = []
        if (icon) {
            fileList = [
                {
                    id: icon.id,
                    uid: '-1',
                    name: icon.file_name,
                    url: icon.url
                }
            ]
        }

        const uploadButton = (
            <div>
                <Icon type={this.state.loading ? 'loading' : 'plus'} />
                <div className="ant-upload-text">Upload</div>
            </div>
        )

        return (
            <Fragment>
                <Upload
                    name="company"
                    listType="picture-card"
                    className="company-uploader"
                    beforeUpload={beforeUpload}
                    customRequest={this.customRequest}
                    onRemove={this.handleRemove}
                    fileList={fileList}
                    multiple={false}
                >
                    {fileList.length >= 1 ? null : uploadButton}
                </Upload>
                <Modal visible={previewVisible} footer={null} onCancel={this.handleCancel}>
                    <img alt="example" style={{ width: '100%' }} src={previewImage} />
                </Modal>
            </Fragment>
        )
    }
}

export default IconUploader
